import { render, staticRenderFns } from "./editUserGroup.vue?vue&type=template&id=7755d4b4&"
import script from "./editUserGroup.vue?vue&type=script&lang=js&"
export * from "./editUserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports